import React from 'react';
import * as styles from '../css/divider-title.css';
import Title from './Title';

const DividerTitle: React.FC = ({ children }) => (
    <Title className={styles.root}>
        {children}
    </Title>
);

export default DividerTitle;
